// extracted by mini-css-extract-plugin
export default {"sign":"I7vlrqTaS8XziXmnPHuY","evidentLink":"IJtNUNhNvDuo15wBul0Q","placeHolderShimmer":"_rfOVtHbqj8_JR3f7Fq2"};